import React from 'react';
import { Listbox, Transition } from '@headlessui/react';
import ValidationWrapper from '../validation/ValidationWrapper';
import { useIcons } from '../../utils/hooks';

/* THIS COMPONENT LACKS LABEL, IT ONLY IMPLEMENTS THE **INPUT**  */

/**
 * Constant values for complex styling props
 */
const defaultClassNameBTN = {
	button: 'w-full flex justify-between items-center focus:outline-none',
	input: 'w-full pb-0.5 focus:outline-none cursor-pointer text-base',
	imgCollapsed: 'transform h-2 ',
	imgOpen: 'transform h-2 rotate-180 ',
};
const defaultTransition = {
	leave: 'transition ease-in duration-100',
	leaveFrom: 'opacity-100',
	leaveTo: 'opacity-0',
};
const defaultClassNameSEARCH = {
	div: 'sticky top-0 flex pb-1 pt-2 px-1',
	input: 'w-full focus:outline-none cursor-pointer',
	img: 'self-center',
};
const defaultClassNameITEM = {
	span: 'w-full flex pt-1 space-x-2 cursor-pointer italic',
	active: '',
	selected: 'font-bold',
	default: '',
};

function PhoneInput({
	name,
	value,
	onChange = () => { },
	dialCodeItems = [],
	colors,
	required,
	checkbbdd,
	translate,

	/* OPTIONAL PROPS */
	id,
	confirmValue,
	confirmError,
	placeholderSearchBar,
	defaultDialCode = '34',
	autoComplete = 'off',
	type = 'number',
	classNameDIV = 'w-full relative flex gap-x-5 items-end',
	styleDIV,
	classNameLISTBOX = 'w-3/12 space-y-2',
	classNameBTN,
	transition,
	classNameOPTS = 'absolute top-10 w-full max-h-60 z-30 space-y-2 flex flex-col py-1 px-2 rounded-sm',
	styleOPTS,
	classNameSEARCH,
	styleSEARCH,
	classNameITEMLIST = 'space-y-2 overflow-y-scroll overscroll-contain',
	classNameITEM,
	styleITEM,
	classNameDIVNUMBER = 'w-full space-y-2',
	classNameNUMBER = 'w-full focus:outline-none text-base',
	styleNUMBER,
	styleINP,
}) {
	/* Dials and filter variables to modify dialCode arrays */
	const [dialItems, setDialItems] = React.useState(dialCodeItems);
	const [dialCodeValue, onChangeDialCode] = React.useState('');
	const [numberValue, onChangeNumber] = React.useState('');
	const [filterValue, setFilterValue] = React.useState('');
	const [defaultDial, setDefaultDial] = React.useState('');
	const [focusNumber, setFocusNumber] = React.useState(false);
	const [focusSearch, setFocusSearch] = React.useState(false);
	const filters = [
		element => element.es.toLowerCase().includes(filterValue)
			|| element.dialCode.includes(filterValue),
		element => element.dialCode !== defaultDialCode
	];

	/* Icon hook */
	const { ArrowDown, Search } = useIcons(colors);

	/* Default values for the styles */
	const defaultStyleDIV = {
		color: colors?.text,
		backgroundColor: colors?.background,
	};
	const defaultStyleINP = {
		backgroundColor: colors?.background,
	};
	const defaultStyleOPTS = {
		border: `1px solid ${colors?.primary}`,
		backgroundColor: colors?.background,
	};
	const defaultStyleSEARCH = {
		borderBottom: `1px solid ${focusSearch ? colors?.primary : colors?.deactivated}`,
		backgroundColor: colors?.background,
	};
	const defaultStyleNUMBER = {
		backgroundColor: colors?.background,
	};
	const styleDialBTN = {
		backgroundColor: colors?.background,
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideClassNameBTN = { ...defaultClassNameBTN, ...classNameBTN };
	const overrideClassNameSEARCH = { ...defaultClassNameSEARCH, ...classNameSEARCH };
	const overrideTransition = { ...defaultTransition, ...transition };
	const overrideStyleDIV = { ...defaultStyleDIV, ...styleDIV };
	const overrideStyleINP = { ...defaultStyleINP, ...styleINP };
	const overrideStyleOPTS = { ...defaultStyleOPTS, ...styleOPTS };
	const overrideStyleSEARCH = { ...defaultStyleSEARCH, ...styleSEARCH };
	const overrideStyleNUMBER = { ...defaultStyleNUMBER, ...styleNUMBER };

	/* Look for default on original list */
	React.useEffect(() => {
		setDefaultDial(dialCodeItems.find(element => element.dialCode === defaultDialCode));
		onChangeDialCode(defaultDialCode);
	}, []);

	/* Apply every filter on Filters each time a different search value is inputed.
	*  Callback + Effect prevent unnecesary rerenders.
	*/
	const filterElements = React.useCallback(() => {
		setDialItems(() => filters.reduce((data, oneFilter) => data.filter(oneFilter), dialCodeItems));
	}, [filterValue]);

	React.useEffect(() => {
		filterElements();
	}, [filterElements]);

	/* After picking one dial code the popup closes and then we clear the input */
	React.useEffect(() => {
		setTimeout(() => setFilterValue(''), 1000);
	}, [dialCodeValue]);

	/* Update real value */
	React.useEffect(() => {
		if (numberValue === null || numberValue === undefined || numberValue < 1) {
			return onChange('');
		}
		return onChange(`+${dialCodeValue}${numberValue}`);
	}, [dialCodeValue, numberValue]);

	/* Handle on focus NUMBER */
	const onFocusNUMBER = event => {
		/* This prevents autocomplete on Chrome */
		if (autoComplete === 'off' && event.target.autocomplete) {
			event.target.autocomplete = 'nothing';
		}
		setFocusNumber(true);
	};

	/* Handle on loose focuse NUMBER */
	const onBlurNUMBER = () => {
		setFocusNumber(false);
	};

	/* Handle on focus SEARCH */
	const onFocusSEARCH = event => {
		/* This prevents autocomplete on Chrome */
		if (autoComplete === 'off' && event.target.autocomplete) {
			event.target.autocomplete = 'nothing';
		}
		setFocusSearch(true);
	};

	/* Handle on loose focuse SEARCH */
	const onBlurSEARCH = () => {
		setFocusSearch(false);
	};

	return <div
		id={id}
		className={classNameDIV}
		style={overrideStyleDIV}
	>
		{/* DIAL CODE SELECTOR */}
		<Listbox value={dialCodeValue} onChange={onChangeDialCode}>
			{({ open }) => (
				<div className={classNameLISTBOX}>

					{/* DIAL BUTTON */}
					<ValidationWrapper
						name={name}
						colors={colors}
						value={value}
						confirmValue={confirmValue}
						confirmError={confirmError}
						required={required}
						checkbbdd={checkbbdd}
						hiddeDefaultError={true}
						isPhoneInput={true}
					>
						<Listbox.Button as='div' className={overrideClassNameBTN.button} style={styleDialBTN}>
							<input
								readOnly
								placeholder={`+${defaultDialCode}`}
								className={overrideClassNameBTN.input}
								style={overrideStyleINP}
								value={`+${dialCodeValue}`} />
							<div className='items-center'>
								{ArrowDown && ArrowDown({
									className: `${open ? overrideClassNameBTN.imgOpen : overrideClassNameBTN.imgCollapsed}`
								})}
							</div>
						</Listbox.Button>
					</ValidationWrapper>

					{/* DIAL LIST */}
					<Transition
						as={React.Fragment}
						leave={overrideTransition.leave}
						leaveFrom={overrideTransition.leaveFrom}
						leaveTo={overrideTransition.leaveTo}
					>
						<Listbox.Options className={classNameOPTS} style={overrideStyleOPTS}>

							{/* SEARCH BAR */}
							<div className={overrideClassNameSEARCH.div} style={overrideStyleSEARCH}>
								<input type='text'
									placeholder={placeholderSearchBar}
									className={overrideClassNameSEARCH.input}
									style={overrideStyleINP}
									autoComplete='off'
									onFocus={onFocusSEARCH}
									onBlur={onBlurSEARCH}
									value={filterValue}
									onChange={event => setFilterValue(event.target.value)} />
								{Search && Search({
									className: overrideClassNameSEARCH.img
								})}
							</div>

							{/* DIAL CODE LIST */}
							<div className={classNameITEMLIST}>

								{/* DEFAULT DIAL CODE */}
								{!filterValue
								&& <Listbox.Option
									value={defaultDial?.dialCode}
								>
									{({ active, selected }) => (
										<DialListItem
											option={defaultDial}
											classNameITEM={classNameITEM}
											styleITEM={styleITEM}
											active={active}
											selected={selected}
											colors={colors}
											translate={translate}
										/>
									)}
								</Listbox.Option>}

								{/* DIAL CODE LIST */}
								{dialItems.map(option => (
									<Listbox.Option
										key={`${option.dialCode} ${option.en}`}
										value={option.dialCode}
									>
										{({ active, selected }) => (
											<DialListItem
												option={option}
												classNameITEM={classNameITEM}
												styleITEM={styleITEM}
												active={active}
												selected={selected}
												colors={colors}
												translate={translate}
											/>
										)}
									</Listbox.Option>
								))}
							</div>
						</Listbox.Options>
					</Transition>
				</div>
			)}
		</Listbox>
		{/* TEXT INPUT */}
		<div className={classNameDIVNUMBER}>
			<ValidationWrapper
				value={value}
				name={name}
				required={required}
				checkbbdd={checkbbdd}
				colors={colors}
				event={focusNumber}
				showIcons={true}
				confirmValue={confirmValue}
				hiddeDefaultError={true}
			>
				<input
					className={classNameNUMBER}
					onChange={event => onChangeNumber(event.target.value)}
					style={overrideStyleNUMBER}
					value={numberValue}
					type={type}
					autoComplete={autoComplete}
					onFocus={onFocusNUMBER}
					onBlur={onBlurNUMBER} />
			</ValidationWrapper>
		</div>
	</div>;
}

/*
* The select list items
*/
function DialListItem({
	option,
	active,
	selected,
	colors,
	translate,
	classNameITEM,
	styleITEM,
}) {
	/* Variables that checks if any point the components are focused or selected */
	const [focusITEM, setFocusITEM] = React.useState(false);

	/* Default values for the styles */
	const defaultStyleITEM = {
		backgroundColor: focusITEM ? colors?.light : colors?.background
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideClassNameITEM = { ...defaultClassNameITEM, ...classNameITEM };
	const overrideStyleITEM = { ...defaultStyleITEM, ...styleITEM };

	/* Handle on focusITEM */
	const onMouseOverITEM = () => setFocusITEM(true);

	/* Handle on loose focuseITEM */
	const onMouseLeaveITEM = () => setFocusITEM(false);

	return <span
		className={`${overrideClassNameITEM.span} ${active && overrideClassNameITEM.active} ${selected && overrideClassNameITEM.selected}`}
		style={overrideStyleITEM}
		onMouseOver={onMouseOverITEM}
		onMouseLeave={onMouseLeaveITEM}
	>
		{/* Be careful with the Optional Chaining here */}
		{`+${option.dialCode} ${option?.[translate?.currentLanguage] ?? option.es}`}
	</span>;
}

export default PhoneInput;
